module.exports = __webpack_public_path__ + "static/media/Younes Yammouri.1396854b.png";